<template>
	<nk-wrapper v-if="context" spacing="md">
		<section id="results">
			<nk-text id="status" tabindex="0">
				Zu Ihrem Suchbegriff "
				<strong>{{ $route.query.q }}</strong>
				"
				{{ context.ergebnis.anzahl > 1 ? 'wurden' : 'wurde' }}
				{{
					context.ergebnis.anzahl === 0
						? 'kein'
						: context.ergebnis.anzahl === 1
							? 'ein'
							: context.ergebnis.anzahl
				}}
				{{ context.ergebnis.anzahl > 1 ? 'Einträge' : 'Eintrag' }} gefunden.
			</nk-text>

			<br v-if="context.ergebnis.anzahl === 0" />

			<nk-list v-else variant="overview" class="suche-uebersicht">
				<template v-for="(ergebnis, index) in context.ergebnis.data">
					<nk-list-item
						v-if="ergebnis._type !== 'ratsinfosystem_sitzungen_berichte'"
						:key="index"
						class="suche-uebersicht__ergebnis"
						:class="{highlight: ergebnis._type === 'suche_webcontact'}"
					>
						<article>
							<!-- Suche Webcontact KI -->
							<template v-if="ergebnis._type === 'webcontact_suche_ki'">
								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<!-- Beschreibung -->
								<div v-html="ergebnis._source.einleitung" />
							</template>

							<!-- Suche Webcontact -->
							<template v-if="ergebnis._type === 'suche_webcontact'">
								<!-- Titel -->
								<nuxt-link :to="ergebnis.url">
									<nk-title tag="h2" size="xl">
										{{ ergebnis.titel }}
									</nk-title>
								</nuxt-link>

								<!-- Beschreibung -->
								<div v-html="ergebnis.beschreibung" />
							</template>

							<!-- Aktuelles -->
							<template v-if="ergebnis._type === 'aktuelles'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Aktuelles</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<!-- Einleitung -->
								<div v-html="ergebnis._source.einleitung" />
							</template>

							<!-- Ämter -->
							<template v-if="ergebnis._type === 'aemter'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Ämter</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<!-- Adresse -->
								<nk-address
									:gebaeude="ergebnis._source.gebaeude"
									:strasse="ergebnis._source.strasse"
									:plz="ergebnis._source.plz"
									:ort="ergebnis._source.ort"
									:telefon="ergebnis._source.telefon"
									:telefax="ergebnis._source.telefax"
									:email="ergebnis._source.email"
									:link="ergebnis._source.link"
									:linktext="ergebnis._source.linktext"
								/>
							</template>

							<!-- Archiv -->
							<template v-if="ergebnis._type === 'archiv'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Archiv</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<a :href="ergebnis._source.es_pfad" target="_blank">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.downloadtext }}
									</nk-title>
								</a>

								<!-- Dokument -->
								<p>
									<a :href="ergebnis._source.es_pfad" target="_blank">
										Dokument herunterladen
									</a>
								</p>
							</template>

							<!-- Portale -->
							<template v-if="ergebnis._type === 'portale'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Portale</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<nk-text v-if="ergebnis._source.einleitung">
									{{ ergebnis._source.einleitung }}
								</nk-text>
							</template>

							<!-- Brancheneinträge -->
							<template v-if="ergebnis._type === 'brancheneintraege'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Brancheneinträge</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<!-- Adresse -->
								<nk-address
									:strasse="ergebnis._source.strasse"
									:plz="ergebnis._source.plz"
									:ort="ergebnis._source.ort"
									:telefon="ergebnis._source.telefon"
									:email="ergebnis._source.email"
									:link="ergebnis._source.link"
									:linktext="ergebnis._source.linktext"
									:geokoordinaten="{
										longitude: ergebnis._source.longitude,
										latitude: ergebnis._source.latitude,
									}"
								/>
							</template>

							<!-- Mitarbeiter -->
							<template v-if="ergebnis._type === 'mitarbeiter'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Mitarbeiter</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.nachname }},
										{{ ergebnis._source.vorname }}
									</nk-title>
								</nuxt-link>

								<!-- Adresse -->
								<nk-address
									:telefon="ergebnis._source.telefon"
									:email="ergebnis._source.email"
								/>
							</template>

							<!-- Shop -->
							<template v-if="ergebnis._type === 'shop'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Shop</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<!-- Einleitung -->
								<div v-html="ergebnis._source.einleitung" />
							</template>

							<!-- Veranstaltungen -->
							<template v-if="ergebnis._type === 'veranstaltungen'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Veranstaltungen</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<div class="time">
									<i class="nk-icons nk-icon-calendar-s mr-1" />
									{{ $getDateTimeString(ergebnis._source) }}
								</div>

								<!-- Einleitung -->
								<div v-html="ergebnis._source.einleitung" />
							</template>

							<!-- Wegweiser -->
							<template v-if="ergebnis._type === 'wegweiser'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Wegweiser</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="extWegweiserUrl(ergebnis._source.es_pfad)">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>
							</template>

							<!-- [Amt24|Service BW] REST API -->
							<template v-if="ergebnis._type === 'online-services-rest-api'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Wegweiser</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<nk-address
									v-if="ergebnis._source.typ === 'KONTAKTPERSON'"
									:telefon="ergebnis._source.telefon"
									:mobil="ergebnis._source.mobiltelefon"
									:fax="ergebnis._source.fax"
									:email="ergebnis._source.email"
								/>

								<!-- Einleitung -->
								<div v-html="ergebnis._source.einleitung" />
							</template>

							<!-- Baugebiete -->
							<template v-if="ergebnis._type === 'baugebiete'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Baugebiete</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>
							</template>

							<!-- Zeitstrahl -->
							<template v-if="ergebnis._type === 'zeitstrahl'">
								<nk-list variant="clean">
									<nk-list-item icon="library">Zeitstrahl</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.titel }}
									</nk-title>
								</nuxt-link>

								<div v-html="ergebnis._source.text" />
							</template>

							<!-- Servicebw -->
							<template v-if="ergebnis._type === 'servicebw_kontaktpersonen'">
								<nk-list variant="clean">
									<nk-list-item icon="library">
										Wegweiser, Kontaktpersonen
									</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.name }}
									</nk-title>
								</nuxt-link>

								<!-- Adresse -->
								<template
									v-for="(k, indexK) in ergebnis._source.content.kontakt"
								>
									<nk-address
										v-if="k.titel === 'Telefon'"
										:key="`k${indexK}`"
										:telefon="k.kennung"
										class="-mb-4"
									/>

									<nk-address
										v-if="k.titel === 'E-Mail'"
										:key="`k${indexK}`"
										:email="k.kennung"
										class="-mb-4"
									/>
								</template>
							</template>

							<template v-if="ergebnis._type === 'servicebw_leistungen'">
								<nk-list variant="clean">
									<nk-list-item icon="library">
										Wegweiser, Leistungen
									</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.name }}
									</nk-title>
								</nuxt-link>
							</template>

							<template
								v-if="ergebnis._type === 'servicebw_organisationseinheiten'"
							>
								<nk-list variant="clean">
									<nk-list-item icon="library">
										Wegweiser, Organisationseinheiten
									</nk-list-item>
								</nk-list>

								<!-- Titel -->
								<nuxt-link :to="ergebnis._source.es_pfad">
									<nk-title tag="h2" size="xl">
										{{ ergebnis._source.name }}
									</nk-title>
								</nuxt-link>
							</template>
						</article>
					</nk-list-item>
				</template>
			</nk-list>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {jumpTo} from '../../composables/ui';

export default {
	name: 'NkTemplateSuche',

	mixins: [TemplatesDefault],

	updated() {
		jumpTo('#status');
	},

	mounted() {
		jumpTo('#status');
	},

	methods: {
		extWegweiserUrl(url) {
			// Wegweiser URL-Korrektur
			let wegweiserUrl = url;
			wegweiserUrl = wegweiserUrl.replace(/^\/|\/$/g, '');
			wegweiserUrl = wegweiserUrl.split('/');

			// Pfad 'verfahren' nicht vorhanden?
			if (wegweiserUrl.findIndex(el => el === 'verfahren') === -1) {
				wegweiserUrl.splice(wegweiserUrl.length - 1, 0, 'verfahren');
			}

			// Pfad 'buchstabe' nicht vorhanden
			if (wegweiserUrl[wegweiserUrl.length - 2].length > 1) {
				const buchstabe = wegweiserUrl[wegweiserUrl.length - 1]
					.charAt(0)
					.toUpperCase();
				wegweiserUrl.splice(wegweiserUrl.length - 1, 0, buchstabe);
			}

			return `/${wegweiserUrl.join('/')}/`;
		},
	},
};
</script>
